import { Component, Input } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ResetFiltersButtonState, ResetFiltersButtonStore, SimpleActionCreator } from '../../helpers/types';
import { InvestmentsParams } from 'src/app/modules/investments/investments.interface';
import { SelfPublishesParams } from 'src/app/modules/self-publishes/self-publishes.interface';
import { UsersParams } from 'src/app/modules/users/users.interface';
import { loadUsers } from '../../../modules/users/store/users.actions';

@Component({
  selector: 'app-reset-filters-button',
  templateUrl: './reset-filters-button.component.html'
})
export class ResetFiltersButtonComponent {
  @Input() action: SimpleActionCreator<any>;
  @Input() params: InvestmentsParams | SelfPublishesParams | UsersParams;
  @Input() state: Observable<ResetFiltersButtonState>;

  constructor(private store: Store<ResetFiltersButtonStore>) {}

  resetFilters(): void {
    this.store.dispatch(this.action(this.params));
  }
}
